import { useSelector } from '@/hooks/redux'
import { Profile } from '@/types'
import { select } from '@/store'

type Optional<T> = T | undefined
type OptionalProfile = Optional<Profile>

const useProfile = (): OptionalProfile => {
  const profile: OptionalProfile = useSelector(select.profile.profile)
  return profile
}

export default useProfile
